import { Palette } from 'lucide-react';

import ApplyPaletteDropdown from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector/ApplyPaletteDropdown';
import ColorSelectionList from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector/ColorSelectionList';
import { EmptyState } from '@/features/dashboard/components/AppForm/AppForm/components/EmptyState';
import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';

const ColorPaletteSelector = () => {
  const { form } = useAppForm();

  return (
    <form.Subscribe selector={s => s.values?.symbols}>
      {symbols => (
        <section className='flex flex-col rounded-xl bg-card p-4'>
          <div className='mb-6 flex flex-col justify-between gap-3 sm:flex-row'>
            <div className='flex flex-col'>
              <h3 className='mb-2 text-sm font-semibold'>Color selection</h3>
              <p className='text-xs font-medium text-muted-foreground'>
                Choose a palette to customize the colors for each line in your chart
              </p>
            </div>
            <ApplyPaletteDropdown />
          </div>
          {symbols && symbols.active.length > 0 && <ColorSelectionList />}
          {(!symbols || symbols.active.length === 0) && (
            <EmptyState
              description='Select items above to configure their chart palette'
              icon={<Palette />}
              title='No colors to configure'
            />
          )}
        </section>
      )}
    </form.Subscribe>
  );
};

export default ColorPaletteSelector;
